import { CategorizedDocumentsList } from "@/components/documents/CategorizedDocumentsList"
import { useDocuments } from "@/components/documents/context/DocumentsProvider"
import { FormHeader } from "@/components/form-elements/FormHeader"
import { Card, CardContent } from "@/components/ui/card"

export function CategorizedDocumentsCard() {
  const { categorized } = useDocuments()

  const bankingDocuments = categorized.filter(
    (doc) => doc.category == "banking",
  )
  const financialsDocuments = categorized.filter(
    (doc) => doc.category == "financials",
  )
  const otherDocuments = categorized.filter((doc) => doc.category == "other")

  return (
    <Card className="w-full border-0 shadow-sm">
      <CardContent>
        <FormHeader title="Categorized" />
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
          <CategorizedDocumentsList
            documents={bankingDocuments}
            title="Banking"
          />
          <CategorizedDocumentsList
            documents={financialsDocuments}
            title="Financials"
          />
          <CategorizedDocumentsList documents={otherDocuments} title="Other" />
        </div>
      </CardContent>
    </Card>
  )
}
